<!-- Left positioned toasts -->
@if (leftToasts().length > 0) {
    <div [ngClass]="getContainerClasses('left')">
        @for (toast of leftToasts(); track toast.id) {
            <div
                appToastTimer
                [toast]="toast"
                [ngClass]="toast.className || 'bg-white shadow rounded flex items-start gap-3 p-4 border max-w-sm'"
                class="relative transition-all duration-300 group"
                #toastTimer="toastTimer"
                #toastEl
            >
                @if (toast.duration && toast.duration > 0) {
                    <div class="absolute left-0 top-0 h-[2px] w-full bg-blue-100" style="overflow: hidden">
                        <div class="h-full bg-slate-400" [style.width.%]="toastTimer.progress() * 100"></div>
                    </div>
                }
                @if (toast.type) {
                    <div class="flex-shrink-0 mr-2">
                        <lucide-icon
                            class="w-7 h-7"
                            [ngClass]="{
                                'text-green-500': toast.type == 'success',
                                'text-red-500': toast.type == 'error',
                                'text-blue-500': toast.type == 'info',
                            }"
                            aria-label="Dismiss"
                            [img]="setIcon(toast.type)"
                            (click)="toastService.dismiss(toast.id)"
                        ></lucide-icon>
                    </div>
                }
                <div class="flex-1 min-w-0 pr-6">
                    @if (toast.title) {
                        <div class="mb-1 font-semibold text-gray-900 break-words">
                            {{ toast.title }}
                        </div>
                    }
                    <div class="text-gray-700">
                        @if (toast.allowHtml) {
                            <div
                                class="text-sm break-words toast-html-content"
                                [innerHTML]="sanitizeHtml(toast.content)"
                            ></div>
                        } @else {
                            <p class="text-sm break-words whitespace-pre-wrap">{{ toast.content }}</p>
                        }
                    </div>
                </div>
                <lucide-icon
                    class="absolute flex-shrink-0 w-5 h-5 text-gray-400 cursor-pointer top-2 right-2 hover:text-gray-700"
                    aria-label="Dismiss"
                    [img]="X"
                    (click)="toastService.dismiss(toast.id)"
                ></lucide-icon>
            </div>
        }
    </div>
}

<!-- Center positioned toasts -->
@if (centerToasts().length > 0) {
    <div [ngClass]="getContainerClasses('center')">
        @for (toast of centerToasts(); track toast.id) {
            <div
                appToastTimer
                [toast]="toast"
                [ngClass]="toast.className || 'bg-white shadow rounded flex items-start gap-3 p-4 border max-w-sm'"
                class="relative transition-all duration-300 group"
                #toastTimer="toastTimer"
                #toastEl
            >
                @if (toast.duration && toast.duration > 0) {
                    <div class="absolute left-0 top-0 h-[2px] w-full bg-blue-100" style="overflow: hidden">
                        <div class="h-full bg-slate-400" [style.width.%]="toastTimer.progress() * 100"></div>
                    </div>
                }
                @if (toast.type) {
                    <div class="flex-shrink-0 mr-2">
                        <lucide-icon
                            class="w-7 h-7"
                            [ngClass]="{
                                'text-green-500': toast.type == 'success',
                                'text-red-500': toast.type == 'error',
                                'text-blue-500': toast.type == 'info',
                            }"
                            aria-label="Dismiss"
                            [img]="setIcon(toast.type)"
                            (click)="toastService.dismiss(toast.id)"
                        ></lucide-icon>
                    </div>
                }
                <div class="flex-1 min-w-0 pr-6">
                    @if (toast.title) {
                        <div class="mb-1 font-semibold text-gray-900 break-words">
                            {{ toast.title }}
                        </div>
                    }
                    <div class="text-gray-700">
                        @if (toast.allowHtml) {
                            <div
                                class="text-sm break-words toast-html-content"
                                [innerHTML]="sanitizeHtml(toast.content)"
                            ></div>
                        } @else {
                            <p class="text-sm break-words whitespace-pre-wrap">{{ toast.content }}</p>
                        }
                    </div>
                </div>
                <lucide-icon
                    class="absolute flex-shrink-0 w-5 h-5 text-gray-400 cursor-pointer top-2 right-2 hover:text-gray-700"
                    aria-label="Dismiss"
                    [img]="X"
                    (click)="toastService.dismiss(toast.id)"
                ></lucide-icon>
            </div>
        }
    </div>
}

<!-- Right positioned toasts -->
@if (rightToasts().length > 0) {
    <div [ngClass]="getContainerClasses('right')">
        @for (toast of rightToasts(); track toast.id) {
            <div
                appToastTimer
                [toast]="toast"
                [ngClass]="toast.className || 'bg-white shadow rounded flex items-start gap-3 p-4 border max-w-sm'"
                class="relative transition-all duration-300 group"
                #toastTimer="toastTimer"
                #toastEl
            >
                @if (toast.duration && toast.duration > 0) {
                    <div class="absolute left-0 top-0 h-[2px] w-full bg-blue-100" style="overflow: hidden">
                        <div class="h-full bg-slate-400" [style.width.%]="toastTimer.progress() * 100"></div>
                    </div>
                }
                @if (toast.type) {
                    <div class="flex-shrink-0 mr-2">
                        <lucide-icon
                            class="w-7 h-7"
                            [ngClass]="{
                                'text-green-500': toast.type == 'success',
                                'text-red-500': toast.type == 'error',
                                'text-blue-500': toast.type == 'info',
                            }"
                            aria-label="Dismiss"
                            [img]="setIcon(toast.type)"
                            (click)="toastService.dismiss(toast.id)"
                        ></lucide-icon>
                    </div>
                }
                <div class="flex-1 min-w-0 pr-6">
                    @if (toast.title) {
                        <div class="mb-1 font-semibold text-gray-900 break-words">
                            {{ toast.title }}
                        </div>
                    }
                    <div class="text-gray-700">
                        @if (toast.allowHtml) {
                            <div
                                class="text-sm break-words toast-html-content"
                                [innerHTML]="sanitizeHtml(toast.content)"
                            ></div>
                        } @else {
                            <p class="text-sm break-words whitespace-pre-wrap">{{ toast.content }}</p>
                        }
                    </div>
                </div>
                <lucide-icon
                    class="absolute flex-shrink-0 w-5 h-5 text-gray-400 cursor-pointer top-2 right-2 hover:text-gray-700"
                    aria-label="Dismiss"
                    [img]="X"
                    (click)="toastService.dismiss(toast.id)"
                ></lucide-icon>
            </div>
        }
    </div>
}
